import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { RegistroNegocioPendienteModel } from './RegistroNegocioPendiente.model'
import { of } from 'rxjs/observable/of';


@Component({
	selector: 'generarInterfaz',
	templateUrl: './GenerarInterfaz.component.html',
	styleUrls: ['../../../../styles.css']

})
export class GenerarInterfazComponent {

	public mes: string;
	public nano: string;
	myControl = new FormControl();
	public form: FormGroup;
	public formErrors: any;
	public cargando: boolean = false;

	public displayedColumns = ['Seleccionar', 'Negocio', 'Pendientes','ControlEscritura'];
	public dataDataBase: RegistroDatabase;
	public dataSource: ExampleDataSource;
	public render: boolean = false;

	public ocultar: boolean= false;
	public mensaje: string="";


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar) {

		this.mes = "";
		this.nano = "";

		this.formErrors = {

			mes: {},
			nano: {}

		};
		this.snackBar.dismiss();
	}

	ngOnInit() {

		this.form = this.formBuilder.group({
			mes: ['', Validators.required],
			nano: ['', Validators.required]
		});

		this.form.valueChanges.subscribe(() => {
			for (const field in this.formErrors) {
				if (!this.formErrors.hasOwnProperty(field)) {
					continue;
				}

				// Clear previous errors
				this.formErrors[field] = {};

				// Get the control
				const control = this.form.get(field);

				if (control && control.dirty && !control.valid) {
					this.formErrors[field] = control.errors;
				}
			}
		});
	}

	public consultarNegocios() {

		this.render = false;
		this.cargando = true;
		this._serviciosGenerales.get('consultarNegociosPendientesContabilizacion', { nmes: this.mes, nano: this.nano, usuario: '', ntipoempresa: -1 }).subscribe(
			result => {
				this.cargando = false;
				if (result.length == 0) {
					this.openSnackBarEspecial("No se encontraron registros", "X");
					return;
				}



				this.dataDataBase = new RegistroDatabase();
				for (let x of result) {
					this.dataDataBase.addRegistro(new RegistroNegocioPendienteModel(x.CNUMCONT, x.PENDIENTES, false,x.CONTROL_ESCRITURA));
				}

				this.dataSource = new ExampleDataSource(this.dataDataBase);
				this.render = true;

			}, error => {
				this.cargando = false;
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
			}
		)
	}


	generarInterfaz() {
		//console.log(JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa);

		this.cargando = true;
		let temporal = [];
		var d = new Date();
		let cidTemp = d.getTime();

		for (let x of this.dataDataBase.data) {
			if (x.activarUsuario == true)
				temporal.push({ id : {cnumcont: x.negocio, cid: cidTemp, ntipoempresa: JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa } });
		}
		this._serviciosGenerales.post('guardar/interfazTemporal', temporal).subscribe(
			result => {
				console.log(result);
				if (result.error == false) {

					this._serviciosGenerales.post('contabilizar', { mes: this.mes, nano: this.nano, cid : cidTemp, usuario: this._serviciosGenerales.seguridad.getInfoSesion().usuario }).subscribe(result => {

						this.openSnackBar(result.mensaje, "X");
						this.cargando = false;

					}, error => {
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de contabilizar", "X");
						this.cargando = false;
					});

				}
			}, error => {
				this.openSnackBarEspecial("Ocurrió un error al momento de almacenar los datos temporales", "X");
				this.cargando = false;
			}
		)

	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }

}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class RegistroDatabase {

	dataChange: BehaviorSubject<RegistroNegocioPendienteModel[]> = new BehaviorSubject<RegistroNegocioPendienteModel[]>([]);

	get data(): RegistroNegocioPendienteModel[] {
		return this.dataChange.value;
	}

	addRegistro(log: RegistroNegocioPendienteModel) {
		const copiedData = this.data.slice();
		copiedData.push(log);
		this.dataChange.next(copiedData);
	}

}

export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: RegistroDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<RegistroNegocioPendienteModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: RegistroNegocioPendienteModel) => {
				let searchStr = (item.negocio).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/GenerarInterfaz/GenerarInterfaz.component.ts